export var RestoreAccountSortField;
(function (RestoreAccountSortField) {
    RestoreAccountSortField["RESTORE_ACCOUNT_SORT_ACCOUNT_NAME"] = "accountName";
    RestoreAccountSortField["RESTORE_ACCOUNT_SORT_INSTALLED_VERSION"] = "installedVersion";
    RestoreAccountSortField["RESTORE_ACCOUNT_SORT_FIRST_CONNECTED"] = "createdAt";
})(RestoreAccountSortField || (RestoreAccountSortField = {}));
